// extracted by mini-css-extract-plugin
export default {"container":"DashboardPage_container__OLTjJ","grid":"DashboardPage_grid__a8CMd"};